// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../src/assets/images/themes/kauz/default/avatar-default.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#close-button {
    cursor: pointer;
    position: absolute;
    overflow: hidden;
    z-index: 1982;
    height: 33px;
    width: 33px;
    right: -17px;
    top: -17px;
    filter: drop-shadow(gray 0px 0.1rem 0.1rem);
}

#close-button svg {
    height: 100%;
    width: 100%;
}

#chat-ui {
    position: fixed;
    overflow: hidden;
    bottom: 50px;
    right: 50px;
    width: 370px;
    height: 80vh;
    max-width: 370px;
    min-width: 300px;
    filter: drop-shadow(0 0.1rem 0.1rem grey);
    min-height: 300px;
    border-radius: 5px;
    z-index: 9999999999;
}

.invisible {
    display: none !important;
}

#chat-ui > div {
    position: absolute;
    top: 17px;
    right: 17px;
    bottom: 0;
    left: 17px;
    background: white;
    border-radius: 15px;
}

#chat-ui > div > iframe {
    border: none;
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 15px;
}

#placeholder {
    position: fixed;
    display: flex;
    align-items: start;
    justify-content: flex-end;
    bottom: 3vh;
    right: 3vh;
    padding: 4px;
    z-index: 1980;
}

#greeting {
    padding: 0.5rem;
    color: var(--chatbot-placeholder-text-color, var(--mat-primary-contrast-500, #ffffff));
    filter: drop-shadow(0 0.1rem 0.1rem grey);
    transition: visibility 0.5s 0.1s;
    border-radius: 5px;
    background-color: var(--chatbot-placeholder-background-color, var(--mat-primary-500, #03a9f4));
    margin-right: 1em;
    max-width: 25em;
    position: relative;
    font-family: 'Poppins', Arial, sans-serif;
}

#greeting::after {
    content: "";
    position: absolute;
    bottom: 30%;
    right: -0.5em;
    border-top: 0.5rem solid transparent;
    border-left: 0.5rem solid var(--chatbot-placeholder-background-color, var(--mat-primary-500, #03a9f4));
    border-bottom: 0.5rem solid transparent;
}

.bot.avatar {
    cursor: pointer;
    filter: drop-shadow(0 0.1rem 0.1rem grey);
    border-radius: 50%;
    height: 5em;
    width: 5em;
    background-color: var(--chatbot-avatar-background-color, var(--mat-secondary-500, #ffffff));
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex: 0 0 auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-top: auto;
}

@media (max-width: 480px) and (orientation: portrait) {
    #chat-ui {
        top: 0;
        left: 0;
        right: auto;
        bottom: auto;
        width: 100vw;
        height: 100vh;
        height: 100dvh;
        max-width: none;
        min-width: 0;
        min-height: 0;
        border-radius: 0;
        filter: none;
    }

    #chat-ui > div {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 0;
    }

    #chat-ui > div > iframe {
        border-radius: 0;
    }

    #placeholder {
        bottom: 1vh;
        right: 1vh;
    }
}

@media (min-width: 481px) and (max-width: 800px) and (orientation: portrait) {
    #chat-ui {
        width: 90vw;
        height: 90vh;
        bottom: 1vh;
        right: 1vh;
    }

    #placeholder {
        bottom: 1vh;
        right: 1vh;
    }
}

@media (min-width: 481px) and (max-width: 800px) and (orientation: landscape) {
    #chat-ui {
        width: 40vw;
        min-width: 360px;
        height: 90vh;
        bottom: 1vh;
        right: 1vw;
    }

    #placeholder {
        bottom: 1vh;
        right: 1vw;
    }
}

@media (min-width: 801px) and (max-width: 1024px) and (orientation: portrait) {
    #chat-ui {
        width: 50vw;
        min-width: 360px;
        right: 1vh;
        bottom: 1vh;
    }

    #placeholder {
        right: 2vh;
        bottom: 2vh;
    }

    #placeholder .bot.avatar {
        height: 6em;
        width: 6em;
    }
}

@media (min-width: 801px) and (max-width: 1024px) and (orientation: landscape) {
    #chat-ui {
        width: 35vw;
        min-width: 360px;
        right: 1vh;
        bottom: 1vh;
    }

    #placeholder {
      right: 2vh;
      bottom: 2vh;
    }

    #placeholder .bot.avatar {
        height: 6em;
        width: 6em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/placeholder.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sFAAsF;IACtF,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,8FAA8F;IAC9F,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,sGAAsG;IACtG,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,2FAA2F;IAC3F,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,cAAc;IACd,yDAAuF;IACvF,gBAAgB;AACpB;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,cAAc;QACd,eAAe;QACf,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,SAAS;QACT,OAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;MACE,UAAU;MACV,WAAW;IACb;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ","sourcesContent":["#close-button {\n    cursor: pointer;\n    position: absolute;\n    overflow: hidden;\n    z-index: 1982;\n    height: 33px;\n    width: 33px;\n    right: -17px;\n    top: -17px;\n    filter: drop-shadow(gray 0px 0.1rem 0.1rem);\n}\n\n#close-button svg {\n    height: 100%;\n    width: 100%;\n}\n\n#chat-ui {\n    position: fixed;\n    overflow: hidden;\n    bottom: 50px;\n    right: 50px;\n    width: 370px;\n    height: 80vh;\n    max-width: 370px;\n    min-width: 300px;\n    filter: drop-shadow(0 0.1rem 0.1rem grey);\n    min-height: 300px;\n    border-radius: 5px;\n    z-index: 9999999999;\n}\n\n.invisible {\n    display: none !important;\n}\n\n#chat-ui > div {\n    position: absolute;\n    top: 17px;\n    right: 17px;\n    bottom: 0;\n    left: 17px;\n    background: white;\n    border-radius: 15px;\n}\n\n#chat-ui > div > iframe {\n    border: none;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    border-radius: 15px;\n}\n\n#placeholder {\n    position: fixed;\n    display: flex;\n    align-items: start;\n    justify-content: flex-end;\n    bottom: 3vh;\n    right: 3vh;\n    padding: 4px;\n    z-index: 1980;\n}\n\n#greeting {\n    padding: 0.5rem;\n    color: var(--chatbot-placeholder-text-color, var(--mat-primary-contrast-500, #ffffff));\n    filter: drop-shadow(0 0.1rem 0.1rem grey);\n    transition: visibility 0.5s 0.1s;\n    border-radius: 5px;\n    background-color: var(--chatbot-placeholder-background-color, var(--mat-primary-500, #03a9f4));\n    margin-right: 1em;\n    max-width: 25em;\n    position: relative;\n    font-family: 'Poppins', Arial, sans-serif;\n}\n\n#greeting::after {\n    content: \"\";\n    position: absolute;\n    bottom: 30%;\n    right: -0.5em;\n    border-top: 0.5rem solid transparent;\n    border-left: 0.5rem solid var(--chatbot-placeholder-background-color, var(--mat-primary-500, #03a9f4));\n    border-bottom: 0.5rem solid transparent;\n}\n\n.bot.avatar {\n    cursor: pointer;\n    filter: drop-shadow(0 0.1rem 0.1rem grey);\n    border-radius: 50%;\n    height: 5em;\n    width: 5em;\n    background-color: var(--chatbot-avatar-background-color, var(--mat-secondary-500, #ffffff));\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    flex: 0 0 auto;\n    background-image: url(\"../../src/assets/images/themes/kauz/default/avatar-default.png\");\n    margin-top: auto;\n}\n\n@media (max-width: 480px) and (orientation: portrait) {\n    #chat-ui {\n        top: 0;\n        left: 0;\n        right: auto;\n        bottom: auto;\n        width: 100vw;\n        height: 100vh;\n        height: 100dvh;\n        max-width: none;\n        min-width: 0;\n        min-height: 0;\n        border-radius: 0;\n        filter: none;\n    }\n\n    #chat-ui > div {\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        border-radius: 0;\n    }\n\n    #chat-ui > div > iframe {\n        border-radius: 0;\n    }\n\n    #placeholder {\n        bottom: 1vh;\n        right: 1vh;\n    }\n}\n\n@media (min-width: 481px) and (max-width: 800px) and (orientation: portrait) {\n    #chat-ui {\n        width: 90vw;\n        height: 90vh;\n        bottom: 1vh;\n        right: 1vh;\n    }\n\n    #placeholder {\n        bottom: 1vh;\n        right: 1vh;\n    }\n}\n\n@media (min-width: 481px) and (max-width: 800px) and (orientation: landscape) {\n    #chat-ui {\n        width: 40vw;\n        min-width: 360px;\n        height: 90vh;\n        bottom: 1vh;\n        right: 1vw;\n    }\n\n    #placeholder {\n        bottom: 1vh;\n        right: 1vw;\n    }\n}\n\n@media (min-width: 801px) and (max-width: 1024px) and (orientation: portrait) {\n    #chat-ui {\n        width: 50vw;\n        min-width: 360px;\n        right: 1vh;\n        bottom: 1vh;\n    }\n\n    #placeholder {\n        right: 2vh;\n        bottom: 2vh;\n    }\n\n    #placeholder .bot.avatar {\n        height: 6em;\n        width: 6em;\n    }\n}\n\n@media (min-width: 801px) and (max-width: 1024px) and (orientation: landscape) {\n    #chat-ui {\n        width: 35vw;\n        min-width: 360px;\n        right: 1vh;\n        bottom: 1vh;\n    }\n\n    #placeholder {\n      right: 2vh;\n      bottom: 2vh;\n    }\n\n    #placeholder .bot.avatar {\n        height: 6em;\n        width: 6em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
